import { ActivityIndicator, Button, Hr, withConfirmationModal } from 'LocalGluons';
import React, { useEffect, useState } from 'react';
import { Text, View } from 'react-native';
import { useStore } from 'Store';
import { t } from 'Locale';
import iconMap from 'LocalGluons/components/Icon/iconMap';
import baseStyles from './ForgottenUsername.jss';
import PressableButton from './forgUserNameComponents/forgottenNameButton';
import ForgottenNameContent from './forgUserNameComponents/forgottenNameContent/forgNameContent';
import { useFocusEffect } from '@react-navigation/native';

type ForgottenUsernameProps = {
    navigation: any;
    setModalContent: any;
};

const ForgottenUsername = ({ navigation, setModalContent }: ForgottenUsernameProps) => {
    const { appManager, setHideLoginHeader } = useStore();
    const [data, setData] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [loading, setLoading] = useState(true);
    const [hideBackButton, setHideBackButton] = useState(false);

    useEffect(() => {
        requestData();
        setHideBackButton(false);
    }, []);

    const requestData = async () => {
        try {
            const {
                backstageConnector: { faq }
            } = appManager.getApi();
            const received = await faq.forgottenUsername();
            setData(received);
        } catch (err) {
            setErrorMessage(err.localizedMessage);
        } finally {
            setLoading(false);
        }
    };

    const close = () => {
        setHideLoginHeader(false);
        navigation.pop();
    };

    function onPressInvoiceTV() {
        setHideBackButton(true);
        setModalContent(
            <ForgottenNameContent
                navigation={navigation}
                setModalContent={setModalContent}
                dataFromResponse={data}
                setHideBackButton={setHideBackButton}
            />
        );
    }

    function onPressSubscribedTV() {
        setModalContent(
            <ForgottenNameContent
                navigation={navigation}
                setModalContent={setModalContent}
                setHideBackButton={setHideBackButton}
            />
        );
    }

    return (
        <>
            <View style={baseStyles.mainContainer}>
                {!loading && (
                    <View style={baseStyles.contentContainer}>
                        <Text style={baseStyles.title}>{t('LOGIN.HELP.USERNAME_TITLE_MOBILES')}</Text>
                        <Hr />
                        <Text style={baseStyles.content}>{t('LOGIN.HELP.USERNAME_TEXT_MOBILES')}</Text>
                        <View style={baseStyles.pressableContainer}>
                            <PressableButton onPress={onPressInvoiceTV} title={'LOGIN.HELP.USERNAME_CONTRACT_BTN_MOBILES'} icon={iconMap.plan_product} />
                            <PressableButton onPress={onPressSubscribedTV} title={'LOGIN.HELP.USERNAME_PREPAID_BTN_MOBILES'} icon={iconMap.credit_card} focus />
                        </View>
                        {!hideBackButton && (<Button
                            onPress={close}
                            style={{ button: baseStyles.button }}
                            title={t('PARTNER.VOYO.CLOSE_BTN')}
                            isSecondary
                        />)}
                    </View>
                )}
                {loading && (<ActivityIndicator />
                )}
            </View>
        </>
    );
};

export default withConfirmationModal(ForgottenUsername);